module.exports = __webpack_public_path__ + "img/FR14505.ba35c49d.png";